import { Trans } from "@lingui/react/macro";
import { lazy, Suspense, useRef } from "react";

import { useAppRouter } from "~/hook/base/useAppRouter.ts";
import { createDraggableSheet } from "~/ui/base/DraggableSheet.tsx";

const QrScanner = lazy(() =>
  import("~/ui/base/QrScanner.tsx").then((res) => ({
    default: res.QrScanner,
  })),
);

export const QrScannerSheet = createDraggableSheet(
  ({ close, descriptionId, titleId }) => {
    const { push } = useAppRouter();

    const navigatedRef = useRef(false);

    const onScan: Parameters<typeof QrScanner>[0]["onScan"] = (scanner) => {
      const email = scanner.data.split("https://yogi-poke.vercel.app/me/")[1];
      if (typeof email !== "string" || navigatedRef.current) return;
      navigatedRef.current = true;
      close();
      push({ pathname: `/user/${email}` });
    };

    return (
      <div className="p-6 pt-2.5">
        <h1
          className="text-lg font-semibold text-zinc-800 dark:text-zinc-100"
          id={titleId}
        >
          <Trans>QR 코드 스캔</Trans>
        </h1>
        <p
          className="pt-3 pb-6 text-sm text-zinc-400 dark:text-zinc-500"
          id={descriptionId}
        >
          <Trans>상대방의 QR 코드를 스캔하여 콕콕! 찌를 수 있어요.</Trans>
        </p>
        <Suspense
          fallback={
            <div className="dark:bg-zinc-850 aspect-square w-full animate-pulse rounded-2xl bg-zinc-100"></div>
          }
        >
          <QrScanner onScan={onScan} />
        </Suspense>
      </div>
    );
  },
);
